/* Syrae — comportements de la page produit : galerie, bundle, ajout au panier, minuteurs, modale, sections à défilement. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------------ Galerie */
  function initGallery(root) {
    var slides = $('[data-slides]', root);
    if (!slides) return;
    var items = $$('.syrae-gallery__slide', slides);
    var dots = $$('[data-dot]', root);
    var thumbs = $$('[data-thumb]', root);
    var thumbList = $('[data-thumblist]', root);
    var prev = $('[data-thumb-prev]', root);
    var next = $('[data-thumb-next]', root);
    var current = 0;

    function setActive(i) {
      current = i;
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      var t = thumbs[i];
      if (t && thumbList) {
        var left = t.offsetLeft - thumbList.offsetLeft - (thumbList.clientWidth - t.offsetWidth) / 2;
        thumbList.scrollTo({ left: left, behavior: 'smooth' });
      }
      updateNav();
    }
    function goTo(i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      slides.scrollTo({ left: items[i].offsetLeft - slides.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    document.addEventListener('syrae:show-media', function (e) {
      for (var k = 0; k < items.length; k++) if (items[k].getAttribute('data-media-id') === String(e.detail.id)) { goTo(k); break; }
    });
    function updateNav() {
      if (prev) prev.classList.toggle('is-disabled', current <= 0);
      if (next) next.classList.toggle('is-disabled', current >= items.length - 1);
    }
    var ticking = false;
    slides.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = items[0] ? items[0].getBoundingClientRect().width : 1;
        var gap = items[1] ? items[1].offsetLeft - items[0].offsetLeft - w : 0;
        var i = Math.round(slides.scrollLeft / (w + gap));
        if (i !== current) setActive(i);
      });
    }, { passive: true });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { goTo(n); }); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    updateNav();
  }

  /* ------------------------------------------------------------------ Bundle + ajout au panier */
  function initProduct(section) {
    var dataEl = $('[data-syrae-product]', section);
    var bundle = $('[data-bundle]', section);
    var form = $('[data-syrae-form]', section);
    if (!dataEl || !form) return;
    var data = JSON.parse(dataEl.textContent);

    function selectTier(n) {
      if (!bundle) return;
      bundle.setAttribute('data-selected', n);
      $$('.syrae-bundle__bar', bundle).forEach(function (bar) {
        var on = bar.getAttribute('data-tier') === String(n);
        bar.classList.toggle('is-selected', on);
        var input = $('input[type=radio]', bar);
        if (input) input.checked = on;
      });
    }
    if (bundle) {
      $$('.syrae-bundle__bar', bundle).forEach(function (bar) {
        var input = $('input[type=radio]', bar);
        input.addEventListener('change', function () { selectTier(bar.getAttribute('data-tier')); });
      });
      bundle.addEventListener('click', function (e) {
        var sw = e.target.closest('.syrae-swatch');
        if (!sw) return;
        e.preventDefault();
        e.stopPropagation();
        var group = sw.parentElement;
        $$('.syrae-swatch', group).forEach(function (s) { s.classList.remove('is-selected'); });
        sw.classList.add('is-selected');
        // image du cadeau = variante choisie ; galerie = image de la couleur de la ceinture
        var gift = sw.closest('.syrae-gift');
        var gimg = gift && $('.syrae-gift__image img', gift);
        if (gimg && sw.getAttribute('data-image')) { gimg.removeAttribute('srcset'); gimg.src = sw.getAttribute('data-image'); }
        if (!gift && sw.getAttribute('data-media-id')) document.dispatchEvent(new CustomEvent('syrae:show-media', { detail: { id: sw.getAttribute('data-media-id') } }));
        // l'utilisateur interagit avec un palier : il devient le palier choisi
        var bar = sw.closest('.syrae-bundle__bar');
        if (bar) selectTier(bar.getAttribute('data-tier'));
      });
    }

    function collect() {
      var tier = 1;
      var bar = null;
      if (bundle) {
        bar = $('.syrae-bundle__bar.is-selected', bundle) || $('.syrae-bundle__bar', bundle);
        tier = +bar.getAttribute('data-tier');
      }
      var offer = bar ? ($('.syrae-bundle__title', bar).textContent || '').trim() : '';
      var lines = [];
      function push(id, props) {
        var key = id + JSON.stringify(props);
        var hit = lines.filter(function (l) { return l._k === key; })[0];
        if (hit) hit.quantity += 1; else lines.push({ id: +id, quantity: 1, properties: props, _k: key });
      }
      if (!bar) {
        push($('[data-variant-id]', form).value, {});
      } else {
        var mainProps = tier === 3 ? { _Offerta: offer } : tier === 2 ? { _Bundle: offer } : {};
        $$('.syrae-bundle__variant', bar).forEach(function (v) {
          var sel = $('.syrae-swatch.is-selected', v) || $('.syrae-swatch', v);
          push(sel.getAttribute('data-variant-id'), mainProps);
        });
        $$('.syrae-gift', bar).forEach(function (g) {
          var sel = $('.syrae-swatch.is-selected', g) || $('.syrae-swatch', g);
          push(sel.getAttribute('data-variant-id'), { _Offerta: offer, _Regalo: 'true' });
        });
      }
      return lines.map(function (l) { return { id: l.id, quantity: l.quantity, properties: l.properties }; });
    }

    var btn = $('[data-atc]', form);
    var err = $('[data-form-error]', section);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      if (err) err.hidden = true;
      // ordre inverse : Shopify empile les nouvelles lignes à l'envers (piège 6.2)
      var items = collect().reverse();
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Errore');
          document.dispatchEvent(new CustomEvent('syrae:cart-updated', { detail: { open: true } }));
        })
        .catch(function (ex) {
          if (err) { err.textContent = ex.message; err.hidden = false; }
        })
        .then(function () { btn.classList.remove('is-loading'); });
    });
  }

  /* ------------------------------------------------------------------ Minuteurs */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function targetFor(el) {
    var end = el.getAttribute('data-end');
    if (end) {
      var d = new Date(end);
      if (!isNaN(d)) return d.getTime();
    }
    var n = new Date();
    var mid = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1, 0, 0, 0);
    return mid.getTime();
  }
  function initCountdown(el) {
    var h = $('[data-cd-h]', el), m = $('[data-cd-m]', el), s = $('[data-cd-s]', el);
    var target = targetFor(el);
    function tick() {
      var left = Math.max(0, Math.floor((target - Date.now()) / 1000));
      if (left === 0) target = targetFor(el);
      h.textContent = pad(Math.floor(left / 3600));
      m.textContent = pad(Math.floor((left % 3600) / 60));
      s.textContent = pad(left % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------------ Date de livraison */
  var DAYS = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
  var MONTHS = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
  var MONTHS_LONG = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
  function deliveryDate(days) { var d = new Date(); d.setDate(d.getDate() + days); return d; }
  function initDelivery(el) {
    var d = deliveryDate(+el.getAttribute('data-min') || 7);
    var out = $('[data-delivery-text]', el);
    if (out) out.innerHTML = DAYS[d.getDay()] + ', <span class="syrae-date-number">' + d.getDate() + '</span> ' + MONTHS[d.getMonth()];
  }

  /* ------------------------------------------------------------------ Modale autenticité */
  function initAuth(section) {
    var open = $('[data-auth-open]', section), modal = $('[data-auth-modal]', section);
    if (!open || !modal) return;
    function toggle(on) { modal.hidden = !on; document.body.classList.toggle('syrae-modal-open', on); }
    open.addEventListener('click', function () { toggle(true); });
    $$('[data-auth-close]', modal).forEach(function (b) { b.addEventListener('click', function () { toggle(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') toggle(false); });
  }

  /* ------------------------------------------------------------------ Compteur de visiteurs (désactivé par défaut) */
  function initLive(el) {
    var min = +el.getAttribute('data-min'), max = +el.getAttribute('data-max');
    var out = $('[data-live-count]', el);
    function rnd() { return Math.floor(min + Math.random() * (max - min + 1)); }
    out.textContent = rnd();
    setInterval(function () { out.textContent = rnd(); }, 9000);
  }

  /* ------------------------------------------------------------------ Curseur avant / après */
  function initBeforeAfter(el) {
    var before = $('[data-ba-before]', el), divider = $('[data-ba-divider]', el), handle = $('[data-ba-handle]', el);
    var labelB = $('[data-ba-label-before]', el), labelA = $('[data-ba-label-after]', el);
    var down = false;
    function set(pct) {
      pct = Math.max(2, Math.min(98, pct));
      before.style.width = pct + '%';
      divider.style.left = pct + '%';
      handle.style.left = pct + '%';
      if (labelB) labelB.classList.toggle('hidden', pct < 18);
      if (labelA) labelA.classList.toggle('hidden', pct > 82);
    }
    function move(clientX) {
      var r = el.getBoundingClientRect();
      set(((clientX - r.left) / r.width) * 100);
    }
    el.addEventListener('pointerdown', function (e) { down = true; el.setPointerCapture(e.pointerId); move(e.clientX); });
    el.addEventListener('pointermove', function (e) { if (down) move(e.clientX); });
    el.addEventListener('pointerup', function () { down = false; });
    el.addEventListener('pointercancel', function () { down = false; });
    set(50);
  }

  /* ------------------------------------------------------------------ Carrousels à défilement (avis, témoignages) */
  function initSlider(root) {
    var track = $('[data-track]', root);
    if (!track) return;
    var prev = $('[data-prev]', root), next = $('[data-next]', root);
    var dots = $$('[data-dot]', root);
    function step() {
      var c = track.children[0];
      if (!c) return track.clientWidth;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return c.getBoundingClientRect().width + gap;
    }
    function active() { return Math.round(track.scrollLeft / step()); }
    function update() {
      var i = active();
      dots.forEach(function (d, n) { d.classList.toggle('active', n === i); });
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { track.scrollTo({ left: n * step(), behavior: 'smooth' }); }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    update();
  }

  /* ------------------------------------------------------------------ Carrousel d'images (résultats) */
  function initFade(root) {
    var slides = $$('[data-slide]', root), dots = $$('[data-dot]', root);
    if (!slides.length) return;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    setInterval(function () { show(i + 1); }, 4500);
  }

  /* ------------------------------------------------------------------ Vidéos de témoignages */
  function initVideoCards(root) {
    $$('[data-video-card]', root).forEach(function (card) {
      var v = $('video', card);
      if (!v) return;
      card.addEventListener('click', function () {
        if (card.classList.contains('playing')) { v.pause(); card.classList.remove('playing'); }
        else {
          $$('[data-video-card].playing').forEach(function (c) { var vv = $('video', c); if (vv) vv.pause(); c.classList.remove('playing'); });
          v.play().then(function () { card.classList.add('playing'); }).catch(function () {});
        }
      });
    });
  }

  /* ------------------------------------------------------------------ Barre d'en-tête collante (apparaît au défilement vers le haut) */
  function initHeader() {
    var wrap = $('sticky-header');
    if (!wrap) return;
    var last = window.scrollY, hidden = false, h = wrap.offsetHeight;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }

  function boot() {
    $$('.syrae-gallery').forEach(initGallery);
    $$('.syrae-pdp').forEach(initProduct);
    $$('.syrae-pdp').forEach(initAuth);
    $$('[data-countdown]').forEach(initCountdown);
    $$('[data-delivery]').forEach(initDelivery);
    $$('[data-live]').forEach(initLive);
    $$('[data-ba]').forEach(initBeforeAfter);
    $$('[data-slider]').forEach(initSlider);
    $$('[data-fade]').forEach(initFade);
    $$('.syrae-ugc').forEach(initVideoCards);
    initHeader();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.Syrae = { deliveryDate: deliveryDate, MONTHS_LONG: MONTHS_LONG, DAYS: DAYS, targetFor: targetFor, pad: pad };
})();
